/**
 * Clinical Center API Manager.
 */
export default class ClinicalCenterApiManager {

  private axios
  private url

  /**
   * Constructor.
   *
   * @param {String} url
   */
  constructor(axios, url) {
    this.axios = axios
    this.url = url
  }

  /**
   * Search all entities.
   *
   * @param {String} search
   * @param {Number} perPage
   * @param {Number} page
   *
   * @returns {Promise<any>}
   */
  async search(search = '', perPage = 10, page = 1) {
    return await this.axios.get(`${this.url}`, {
      search,
      perPage,
      page
    });
  }
}



// WEBPACK FOOTER //
// ./src/modules/user/api/managers/ClinicalCenterApiManager.ts